import { render, staticRenderFns } from "./DatePickerDialog.vue?vue&type=template&id=3135345b&scoped=true"
import script from "./DatePickerDialog.vue?vue&type=script&lang=ts"
export * from "./DatePickerDialog.vue?vue&type=script&lang=ts"
import style0 from "./DatePickerDialog.vue?vue&type=style&index=0&id=3135345b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3135345b",
  null
  
)

export default component.exports